import { Category } from './category'
import { Subsidiary } from './subsidiary'

export class Store {
    storeId!: string
    name!: string
    label!: string
    imageUrl!: string
    smallImageUrl!: string
    backgroundColor!: string
    fontColor!: string
    categories!: Category[]
    subsidiaries!: Subsidiary[]
    deliveryCost!: number
    serviceCost!: number
    viewRanking!: number
    paymentToken!: string
    externalPaymentToken!: string
    deleted!: boolean
    type!: string
    enablePartialPayment!: boolean
    companyCodeSPSA!: string 
    enableSPSANotify!: boolean
    commerceName!: string 
    commerceCode!: string 

}

